// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2sTKH","content":"RecentSearches_content__2Vbv8"};